import { useContext } from 'react';

import { AuthContext, AuthContextValue } from 'hooks/AuthProvider';

const useAuth = (): AuthContextValue => useContext(AuthContext);

export default useAuth;
